class Modal {
  constructor(el) {
    this.el = el;
    this.type = el.getAttribute('type');
  }

  trigger(e) {
    this.open(e.currentTarget.getAttribute('data-target'));
  }

  open() {
    this.el.classList.add('is-open');
  }

  close() {
    this.el.classList.remove('is-open');
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./scripts/components/modals/modal-base.js